import React, { useEffect, useState } from "react";
import "./about.css";
import logo from "../../assets/images/logo.png";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import { ThreeCircles, ThreeDots } from "react-loader-spinner";

import UseGeneral from "../../hooks/useGeneral";
import { useSelector } from "react-redux";
import ContentLoader from "react-content-loader";
const About = () => {
  const [loading, setLoading] = useState(false);
  const { language, data } = UseGeneral();
  const [logo, setLogo] = useState();
  const siteData = useSelector((state) => state?.site?.siteData);
  return (
    <div className="about-container">
      {loading ? (
                  <ThreeDots />

      ) : (
        <>
          <div className="logo">
            <img src={siteData?.logo} alt="" />
          </div>
          <div className="description">
            {language == "ar"
              ? siteData?.description_ar
              : siteData?.description_en}
          </div>
        </>
      )}
    </div>
  );
};

export default About;
